import { usePostMutation } from "@/api/swr/useMutation";
import { RegularAssessmentCreateSchema } from "@/schema/console/regular-assessments/RegularAssessmentDetail";
import { z } from "zod";

export function useCreateRegularAssessment() {
  return usePostMutation(
    RegularAssessmentCreateSchema,
    z.null(),
    "/console/assessment_papers",
  );
}
